"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartCms = void 0;
var promoCard_cms_1 = require("../components/panels/PromoPanel/PromoCard/promoCard.cms");
var yourSavingsCard_cms_1 = require("../components/panels/PromoPanel/YourSavingsCard/yourSavingsCard.cms");
var promoPanel_cms_1 = require("../components/panels/PromoPanel/promoPanel.cms");
var FutureBills_cms_1 = require("../components/FutureBills/FutureBills.cms");
var RemoveModalContent_cms_1 = require("../components/CartLob/shared/RemoveModalContent/RemoveModalContent.cms");
var IncompleteCart_cms_1 = require("../components/atoms/IncompleteCart/IncompleteCart.cms");
var WirelessCart_cms_1 = require("../components/CartLob/WirelessCart/WirelessCart.cms");
var BroadbandCart_cms_1 = require("../components/CartLob/BroadbandCart/BroadbandCart.cms");
var SaveRetrieveCart_cms_1 = require("../components/cards/SaveRetrieveCart/SaveRetrieveCart.cms");
var CartConfiguration_cms_1 = require("../components/CartConfigurationContainer/CartConfiguration.cms");
var AdvertismentPanel_cms_1 = require("../components/CartConfigurationContainer/AdvertismentPanel.cms");
var AccessoriesCart_cms_1 = require("../components/CartLob/AccessoriesCart/AccessoriesCart.cms");
var OrderTotals_cms_1 = require("../components/panels/OrderTotals/OrderTotals.cms");
var CloserCoupon_cms_1 = require("../components/CartLob/shared/CloserCoupon/CloserCoupon.cms");
var ShareCart_cms_1 = require("../components/CartLob/shared/ShareCart/ShareCart.cms");
var MonthlySavingsPanel_cms_1 = require("../components/panels/MonthlySavingsPanel/MonthlySavingsPanel.cms");
var SavingsAndPromos_cms_1 = require("../components/panels/SavingsAndPromos/SavingsAndPromos.cms");
var CartCms = /** @class */ (function () {
    function CartCms() {
        // http://zlt18312.vci.att.com:7280/content/idp/sales/prod/buy/cartcheckout.cmsfeed.js check this
        this.accessorycart = {
            cartSummary: new AccessoriesCart_cms_1.AccessoriesCartCms(),
        };
        this.wirelessCart = {
            cartSummary: new WirelessCart_cms_1.WirelessCartSummaryCms(),
            plansList: new WirelessCart_cms_1.WirelessCartSummaryCms().plansList,
        };
        this.broadbandCart = {
            cartSummary: new BroadbandCart_cms_1.BroadbandCartCms(),
        };
        this.closureCoupon = {
            closureCoupon: new CloserCoupon_cms_1.ClosureCouponCms(),
        };
        this.shareCart = {
            shareCart: new ShareCart_cms_1.ShareCartCms(),
        };
        this.common = {
            advertismentPanel: new AdvertismentPanel_cms_1.AdvertismentPanelCms(),
            cartConfiguration: new CartConfiguration_cms_1.CartConfigurationCms(),
            futureBills: new FutureBills_cms_1.FutureBillsCms(),
            incompleteCart: new IncompleteCart_cms_1.IncompleteCartCms(),
            monthlySavingsPanel: new MonthlySavingsPanel_cms_1.MonthlySavingsCMS(),
            orderTotals: new OrderTotals_cms_1.OrderTotalsCms(),
            promoCart: new promoCard_cms_1.PromoCardCms(),
            promoPanel: new promoPanel_cms_1.PromoPanelCms(),
            removeModal: new RemoveModalContent_cms_1.RemoveModalContentCms(),
            saveRetrieveCart: new SaveRetrieveCart_cms_1.SaveRetrieveCartCms(),
            savingsAndPromos: new SavingsAndPromos_cms_1.SavingsAndPromosCms(),
            sisfoOrder: new CartConfiguration_cms_1.CartConfigurationCms(),
            yourSavings: new yourSavingsCard_cms_1.YourSavingsCardCms(),
        };
    }
    CartCms.prototype.cmstransformer = function (obj) {
        return obj.cart;
    };
    return CartCms;
}());
exports.CartCms = CartCms;
//# sourceMappingURL=Cart.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/cms/Cart.cms.js
// module id = 32
// module chunks = 8